import { ChangeDetectionStrategy, Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { ITab } from "../../../app/shared/model/ITab";

export enum TabDisplay {
    ROWS = 'rows',
    COLUMNS = 'columns',
}

@Component({
    selector: 'tab-navigation',
    template: `
        <ul [ngClass]="display"
            [class]="classList">
            <ng-container *ngFor="let tab of tabs">
                <ng-container *ngIf="tab.permission">
                    <li *permissionIf="tab.permission"
                        class="tab"
                        [hidden]="!tab.allow"
                        [ngClass]="{ 'selected': tab.active, 'disabled': tab.disabled }"
                        [matTooltip]="deactivationReason"
                        [matTooltipDisabled]="!tab.disabled">
                        <a class="e2e-menu-sasha" [routerLink]="tab.disabled ? [] : tab.routerLink"
                           [queryParams]="tab.queryParams"
                           (click)="changeTab(tab)">
                            {{ tab.label }}
                        </a>
                    </li>
                </ng-container>
                <ng-container *ngIf="!tab.permission">
                    <li class="tab"
                        [hidden]="!tab.allow"
                        [ngClass]="{ 'selected': tab.active, 'disabled': tab.disabled }"
                        [matTooltip]="deactivationReason"
                        [matTooltipDisabled]="!tab.disabled">
                        <a class="e2e-menu-sasha" [routerLink]="tab.disabled ? [] : tab.routerLink"
                           [queryParams]="tab.queryParams"
                           (click)="changeTab(tab)">
                            {{ tab.label }}
                        </a>
                    </li>
                </ng-container>
            </ng-container>

        </ul>`,
    styleUrls: ['./tab-navigation.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class TabNavigationComponent implements OnInit {
    @Input()
    public tabs: ITab[];

    @Input()
    public display: TabDisplay;

    @Input()
    public classList: string = '';

    @Input()
    public deactivationReason: string = null;

    @Output()
    public readonly onChangeTab: EventEmitter<ITab[]> = new EventEmitter();

    public ngOnInit(): void {
        const defaultTab: ITab = (this.tabs || []).find((tab: ITab) => tab.active);

        if (defaultTab && defaultTab.tabs && defaultTab.tabs.length !== 0) {
            this.onChangeTab.emit(defaultTab.tabs);
        }
    }

    public changeTab(clickedTab: ITab): void | boolean {
        if (!clickedTab.active && !clickedTab.disabled) {
            this.tabs = (this.tabs || []).map((oldTab: ITab) => ({
                ...oldTab,
                active: oldTab === clickedTab
            }));
        }

        this.onChangeTab.emit(clickedTab.tabs);
    }
}
